import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, MapPin, Briefcase, Bot, User } from "lucide-react";
import { cn } from "@/utils/utils";
import { useIsMobile } from "@/controllers/hooks/use-mobile";

const HIDDEN_PATHS = [
  "/login",
  "/cadastro",
  "/recuperar",
  "/boas-vindas",
  "/admin",
  "/test",
  "/terms",
  "/privacy",
];

const navItems = [
  {
    id: "home",
    label: "Home",
    icon: Home,
    path: "/dashboard",
    matchAlso: [] as string[],
  },
  {
    id: "templos",
    label: "Templos",
    icon: MapPin,
    path: "/jornada",
    matchAlso: ["/templo"],
  },
  {
    id: "negocio",
    label: "Negócio",
    icon: Briefcase,
    path: "/meu-negocio",
    matchAlso: [] as string[],
  },
  {
    id: "mentor",
    label: "Mentor",
    icon: Bot,
    path: "/mentor",
    matchAlso: ["/historico"],
  },
  {
    id: "perfil",
    label: "Perfil",
    icon: User,
    path: "/perfil",
    matchAlso: ["/configuracoes", "/dados-conta"],
  },
];

export function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();

  const shouldHide =
    location.pathname === "/" ||
    HIDDEN_PATHS.some((path) => location.pathname.startsWith(path));

  if (!isMobile || shouldHide) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-black/[0.06] z-50 safe-area-bottom">
      <div className="flex items-center justify-around py-1.5">
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.id === "home" && location.pathname === "/") ||
            item.matchAlso.some((p) => location.pathname.startsWith(p));
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center py-1.5 px-3 min-w-0 flex-1"
            >
              <div
                className={cn(
                  "w-8 h-8 rounded-lg flex items-center justify-center mb-0.5 transition-colors",
                  isActive ? "bg-accent-800/[0.07]" : "",
                )}
              >
                <Icon
                  className={cn(
                    "w-[18px] h-[18px] transition-colors",
                    isActive ? "text-accent-800" : "text-neutral-400",
                  )}
                />
              </div>
              <span
                className={cn(
                  "text-[10px] leading-tight transition-colors",
                  isActive
                    ? "text-accent-800 font-semibold"
                    : "text-neutral-400 font-medium",
                )}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
